import { Link } from "react-router-dom";
import Map from "../components/map/map";
import OpeningHours from "../components/openinghours/OpeningHours";
import ContactForm from "../components/contactform/ContactForm";
import { GoodToKnow, SectionLabel } from "../components/site/Blocks";
import { MailIcon, MapPinIcon, PhoneIcon } from "../components/site/Icons";
import useStatusStore from "../store/statusStore";
import { getClosureText } from "../config/hours";
import { CONTACT, LOCATION, ROUTE_URL } from "../config/location";

const Kontakt = () => {
    const closure = useStatusStore((state) => state.closure);
    const closureText = closure && getClosureText(closure);

    return (
        <>
            <section className="sec page-head grid-3 !items-end pb-16 desk:pb-20">
                <div className="eyebrow hero-in" style={{ animationDelay: ".1s" }}>
                    Kontakt
                </div>
                <h1 className="h1-page m-0 hero-in" style={{ animationDelay: ".25s" }}>
                    So finden Sie uns
                </h1>
                <div className="hero-in" style={{ animationDelay: ".4s" }}>
                    <address className="font-caslon text-[clamp(20px,2vw,26px)] not-italic leading-[1.45]">
                        {LOCATION.venue}
                        <br />
                        {LOCATION.street}
                        <br />
                        {LOCATION.city}
                    </address>
                    {/* Schnellaktionen: die häufigsten Wünsche auf dem Handy */}
                    <div className="mt-6 flex flex-wrap gap-3">
                        <a href={CONTACT.phoneHref} className="btn btn-primary px-5 py-3.5 normal-case tracking-normal">
                            <PhoneIcon />
                            {CONTACT.phone}
                        </a>
                        <a
                            href={`mailto:${CONTACT.email}`}
                            className="btn btn-secondary px-5 py-3.5 normal-case tracking-normal"
                        >
                            <MailIcon />
                            E-Mail schreiben
                        </a>
                        <a
                            href={ROUTE_URL}
                            target="_blank"
                            rel="noreferrer"
                            className="btn btn-secondary px-5 py-3.5 normal-case tracking-normal"
                        >
                            <MapPinIcon />
                            Route planen
                        </a>
                    </div>
                </div>
            </section>

            <section id="kontaktanfrage" className="sec sec-y-md grid-3w bg-leinen scroll-mt-24">
                <SectionLabel>Nachricht</SectionLabel>
                <div>
                    <p className="body-text reveal m-0 max-w-[400px]">
                        Wir freuen uns auf Ihre Anfrage. Füllen Sie einfach das Formular aus und wir melden uns bei
                        Ihnen. Tischreservierungen bitte über{" "}
                        <Link to="/reservierung" className="underline">
                            Reservierung
                        </Link>
                        .
                    </p>
                </div>
                <ContactForm />
            </section>

            <section id="oeffnungszeiten" className="sec sec-y grid-3 scroll-mt-8">
                <SectionLabel>Öffnungszeiten</SectionLabel>
                <OpeningHours />
                <div>
                    {closureText && (
                        <div className="reveal d1 bg-leinen p-10">
                            <div className="eyebrow mb-4">
                                {closureText.label}
                            </div>
                            <div className="mb-3 font-caslon text-2xl leading-[1.35]">{closureText.period}</div>
                            {closureText.reopen && <div className="body-text !text-base">{closureText.reopen}</div>}
                        </div>
                    )}
                    <GoodToKnow className={`reveal d2 ${closureText ? "mt-12" : ""}`} />
                </div>
            </section>

            <section aria-label="Karte" className="sec pb-[88px] desk:pb-[140px]">
                <Map />
            </section>
        </>
    );
};

export default Kontakt;
